import { render, staticRenderFns } from "./MaintainStockEdit.vue?vue&type=template&id=1f70f996"
import script from "./MaintainStockEdit.vue?vue&type=script&lang=js"
export * from "./MaintainStockEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports